<template>
  <div>
    SpecialBlock old
  </div>
</template>

<script>
import { defineNuxtComponent } from "#imports";
import CmsBlockMixin from "#sitis/cms/CmsBlockMixin.vue";
export default defineNuxtComponent({
  extends: CmsBlockMixin,
  setup() {
    return {};
  }
});
</script>

<style>

</style>
